import { render, staticRenderFns } from "./CustomFormRecord.vue?vue&type=template&id=06161693&"
import script from "./CustomFormRecord.vue?vue&type=script&lang=js&"
export * from "./CustomFormRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06161693')) {
      api.createRecord('06161693', component.options)
    } else {
      api.reload('06161693', component.options)
    }
    module.hot.accept("./CustomFormRecord.vue?vue&type=template&id=06161693&", function () {
      api.rerender('06161693', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/CustomForm/CustomFormRecord/CustomFormRecord.vue"
export default component.exports